<div class="task-list-data ce-upload" [class.d-none]="fileUploadValid && !isErrorInSelectedDoc">
    <div id="ce-upload" data-keyboard="false">
      <div class="heading-dialog">
        <div class="list-content">
          <div class="list-header">
            <h4 class="list-title">Upload Document(s)</h4>
            <button type="button" class="close" aria-label="close" data-dismiss="modal" (click)="close(false)">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                <rect width="28" height="28" rx="6" fill="none" />
                <g transform="translate(4 4)">
                  <rect width="20" height="20" fill="none" />
                  <path d="M10,11.229,5.979,15.25a.789.789,0,0,1-.6.24.863.863,0,0,1-.6-.261.88.88,0,0,1,0-1.229l4-4L4.75,5.979a.8.8,0,0,1-.24-.614.875.875,0,0,1,.261-.615A.88.88,0,0,1,6,4.75l4,4.021L14.021,4.75A.869.869,0,0,1,15.25,5.979L11.229,10l4.021,4.021a.855.855,0,0,1,0,1.208.88.88,0,0,1-1.229,0Z"
                        transform="translate(-0.005 0.005)" fill="#757575" />
                </g>
              </svg>
            </button>
          </div>
          <div class="list-body">
            <div class="group-form">
              <div class="common-table">
                <table class="table contact-list-table">
                  <thead class="sticky-from-top">
                    <tr>
                      <th scope="col" style="padding-left: 32px;">File Name</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let file of newUploadedFile">
                      <td class="max-width-tooltip-450" style="padding-left: 32px;">
                        {{file.fileName}}
                        <p *ngIf="file.errorMessagesFileFormat?.length > 0" class="validation-field">{{file.errorMessagesFileFormat}} </p>
                        <p *ngIf="file.errorMessagesFileSize?.length > 0" class="validation-field">{{file.errorMessagesFileSize}} </p>
                        <p *ngIf="file.errorMessagesFileType?.length > 0" class="validation-field">{{file.errorMessagesFileType}} </p>
                      </td>
                      <td style="text-align: left; width: 70px;">
                        <button type="button" class="close status-icon" aria-label="close" data-dismiss="modal" (click)="removedSelectedFile(file.id)" style="width: 100%; text-align: left;">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <rect data-name="Rectangle 18059" width="20" height="20" fill="none" />
                            <path d="M10,11.229,5.979,15.25a.789.789,0,0,1-.6.24.863.863,0,0,1-.6-.261.88.88,0,0,1,0-1.229l4-4L4.75,5.979a.8.8,0,0,1-.24-.614.875.875,0,0,1,.261-.615A.88.88,0,0,1,6,4.75l4,4.021L14.021,4.75A.869.869,0,0,1,15.25,5.979L11.229,10l4.021,4.021a.855.855,0,0,1,0,1.208.88.88,0,0,1-1.229,0Z" transform="translate(-0.005 0.005)" fill="#757575" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style="padding-top:8px;" *ngIf="errorMessages?.length > 0">
                  <validation-summary [validationErrors]="errorMessages"></validation-summary>
                </div>              
              </div>
            </div>
          </div>
          <div class="list-footer">
            <div class="action-btn-block justify-content-end mb-0">
              <button type="button" class="btn btn-md basic-btn" (click)="close(false)">Cancel</button>
              <button type="button" class="btn btn-md primary-btn" [disabled]="this.fileUploadValid == false" (click)="uploadFiles()">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
